module.exports = __webpack_public_path__ + "static/media/no-projects.d93d50fe.svg";